import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-pcdb-data-table-view',
  templateUrl: './pcdb-data-table-view.component.html'
})

export class PcdbDataTableViewComponent implements OnInit {
  result: any[] = [];
  @Input() items: any;
  @Input() hhrshsystem: string;
  @Input() mainSystem1StorageHeaters: any;
  @Input() mainSystem2StorageHeaters: any;
  @Output() onSelectData = new EventEmitter<any>(); 


  ngOnInit(): void {
    this.items.forEach((element, key) => {
      this.result[key] = {};
      this.result[key].key = key;
      this.result[key].value = element;
      this.result[key].hhrshsystem = this.hhrshsystem;
      if(this[`${this.hhrshsystem}StorageHeaters`]) {
        this[`${this.hhrshsystem}StorageHeaters`].forEach((el, k) => {
          if(this[`${this.hhrshsystem}StorageHeaters`][k].indexNumber && (this[`${this.hhrshsystem}StorageHeaters`][k].indexNumber == this.result[key].value.id)) {
            this.result[key].numberOfHeaters = this[`${this.hhrshsystem}StorageHeaters`][k]?.numberOfHeaters || null;
            this.result[key].selected = true;
          } 
        });
      }
    });
    this.result = (this.result) ? this.result : this.items;
  }
  
  selectPcdbData(data) {
    const checked = data.selected;
    if(this.hhrshsystem) {
      data.hhrshsystem = this.hhrshsystem;
    }
    if(this.hhrshsystem == 'mainSystem1') {
      const existDataInHeating = this.mainSystem1StorageHeaters.findIndex(item => item.indexNumber == data.value.id);
      if(checked && existDataInHeating < 0) {
        this.mainSystem1StorageHeaters.push({
          numberOfHeaters: data.numberOfHeaters || null,
          indexNumber: data.value.id,
          highHeatRetention: (data.value.highHeatRetention === '1') ? true : false,
        });
      } else if(!checked && existDataInHeating >= 0) {
        this.mainSystem1StorageHeaters.splice(existDataInHeating, 1);
      } else if (checked && existDataInHeating >= 0 ) {
        this.mainSystem1StorageHeaters[existDataInHeating] = {
          numberOfHeaters: data.numberOfHeaters || null,
          indexNumber: data.value.id,
          highHeatRetention: (data.value.highHeatRetention === '1') ? true : false,
        };
      }
      this.onSelectData.emit(this.mainSystem1StorageHeaters);
    } else if (this.hhrshsystem == 'mainSystem2') {
      const existDataInHeating = this.mainSystem2StorageHeaters.findIndex(item => item.indexNumber == data.value.id);
      if(checked && existDataInHeating < 0) {
        this.mainSystem2StorageHeaters.push({
          numberOfHeaters: data.numberOfHeaters || null,
          indexNumber: data.value.id,
          highHeatRetention: (data.value.highHeatRetention === '1') ? true : false,
        });
      } else if(!checked && existDataInHeating >= 0) {
        this.mainSystem2StorageHeaters.splice(existDataInHeating, 1);
      } else if (checked && existDataInHeating >= 0 ) {
        this.mainSystem2StorageHeaters[existDataInHeating] = {
          numberOfHeaters: data.numberOfHeaters || null,
          indexNumber: data.value.id,
          highHeatRetention: (data.value.highHeatRetention === '1') ? true : false,
        };
      }
      this.onSelectData.emit(this.mainSystem2StorageHeaters);
    }
  }
}
